import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import React, { useState } from "react";
import Disclosures from "./Disclosures";
import { t } from "i18next";

export const DisclosureHome = () => {
  const [value, setValue] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <div className="flex flex-row justify-between">
        <Box
          sx={{
            // borderBottom: 1,
            marginLeft: 2,
            borderColor: "divider",
            width: "fit-content",
          }}
        >
          <TabList onChange={handleChange}>
            <Tab
              value="1"
              sx={{ fontWeight: value === "1" ? "bold" : "regular" }}
              label="GRI"
            />
            <Tab
              value="2"
              sx={{ fontWeight: value === "2" ? "bold" : "regular" }}
              label="TCFD"
            />
            <Tab
              value="3"
              sx={{ fontWeight: value === "3" ? "bold" : "regular" }}
              label="GSTC"
            />
            <Tab
              value="4"
              sx={{ fontWeight: value === "4" ? "bold" : "regular" }}
              label="BRSR"
            />
          </TabList>
        </Box>
      </div>
      <div>
        <TabPanel value="1">
          <Disclosures reportName="gri" />
        </TabPanel>
        <TabPanel value="2">
          <Disclosures reportName="tcfd" />
        </TabPanel>
        <TabPanel value="3">
          <Disclosures reportName="gstc" />
        </TabPanel>
        <TabPanel value="4">
          <Disclosures reportName="brsr" />
        </TabPanel>
      </div>
    </TabContext>
  );
};
